module.exports = __webpack_public_path__ + "static/media/logo_bradesco_horizontal.35f715bd.svg";